(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-gallery-detail-page"]) return;
  try {
    

const desktopHeight = parseInt( $('.gallery-element').data('elementheight') );
const mobileHeight = parseInt( $('.gallery-element').data('mobileheight') );
console.log("I am here:", desktopHeight);

if (matchMedia) {
    const mq = window.matchMedia("(min-width: 750px)"); 
    mq.addListener(WidthChange); 
    WidthChange(mq);
} 
 

function WidthChange(mq) { 	  
    let changeHeight = (mq.matches ? desktopHeight + "px" : mobileHeight + "px");
 	console.log("Triggered:", desktopHeight, " mobileHeight:", mobileHeight);
	var mx = document.getElementById("current").querySelectorAll(".gallery-element");
	var i;
	for (i = 0; i < mx.length; i++) {
       mx[i].style.height = changeHeight;
    }	
}

 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-gallery-page"]) return;
  try {
    

const desktopHeight = parseInt( $('.gallery-element').data('elementheight') );
const mobileHeight = parseInt( $('.gallery-element').data('mobileheight') );
console.log("I am here:", desktopHeight);

if (matchMedia) {
    const mq = window.matchMedia("(min-width: 750px)"); 
    mq.addListener(WidthChange); 
    WidthChange(mq);
} 
 

function WidthChange(mq) { 	  
    let changeHeight = (mq.matches ? desktopHeight + "px" : mobileHeight + "px");
 	console.log("Triggered:", desktopHeight, " mobileHeight:", mobileHeight);
	var mx = document.getElementById("current").querySelectorAll(".gallery-element");
	var i;
	for (i = 0; i < mx.length; i++) {
       mx[i].style.height = changeHeight;
    }	
}

 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function focusSearchMethod() {           
  document.getElementsByName("q").focus();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};

                                                        
                                                      
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-links"]) return;
  try {
    

  var lastClick;
  var accordianActions = document.querySelectorAll('[data-accordian-action]');
  var accordianTargets = document.querySelectorAll('[data-accordian-target]');
  
  var hideTargets = function () {
    for (var i = 0; i < accordianTargets.length; i++) {
      var accordianTarget = accordianTargets[i];
      accordianTarget.style.display = 'none';
   		}
	};
  
  var showTarget = function (targetSelector) {
    var target = document.querySelector(targetSelector);
    target.style.display = 'block';
  };

  hideTargets(); 
  
  for (var i = 0; i < accordianActions.length; i++) {
    var accordianAction = accordianActions[i];
    accordianAction.addEventListener('click', function (e) {
      e.preventDefault();
      hideTargets();
      if (lastClick !== e.currentTarget) {
        showTarget(e.currentTarget.getAttribute('href'));
        lastClick = e.currentTarget;
      } else {
        lastClick = null; 
      }
    });
  };

var smartClick = function () {
	if (matchMedia) {
		var mq = window.matchMedia("(max-width: 749px)"); 
		WidthChange(mq); 
	}

	function WidthChange(mmq) {
		if (mmq.matches) {
		console.log("I hide it");
		hideTargets();
			} else {
		console.log("I show it");
		document.getElementById('clickon').click();
			}
		} 
	}
 
	onload=smartClick();
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sens-surface-gallery"]) return;
  try {
    

const desktopHeight = parseInt( $('.gallery-element').data('elementheight') );
const mobileHeight = parseInt( $('.gallery-element').data('mobileheight') );
console.log("I am here:", desktopHeight);

if (matchMedia) {
    const mq = window.matchMedia("(min-width: 750px)"); 
    mq.addListener(WidthChange); 
    WidthChange(mq);
} 
 

function WidthChange(mq) { 	  
    let changeHeight = (mq.matches ? desktopHeight + "px" : mobileHeight + "px");
 	console.log("Triggered:", desktopHeight, " mobileHeight:", mobileHeight);
	var mx = document.getElementById("current").querySelectorAll(".gallery-element");
	var i;
	for (i = 0; i < mx.length; i++) {
       mx[i].style.height = changeHeight;
    }	
}

 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-page"]) return;
  try {
    


const mH = parseInt( $('.gallery-element').data('elementheight') );
const mobileHeight = parseInt( $('.gallery-element').data('mobileheight') );

if (matchMedia) {
    const mq = window.matchMedia("(min-width: 750px)"); 
    mq.addListener(WidthChange); 
    WidthChange(mq);
} 
 

function WidthChange(mq) { 	  
    let changeHeight = (mq.matches ? mH + "px" : mobileHeight + "px");
 	console.log("Triggered:", mH, " mobileHeight:", mobileHeight);
	var mx = document.getElementById("current").querySelectorAll(".gallery-element");
	var i;
	for (i = 0; i < mx.length; i++) {
       mx[i].style.height = changeHeight;
    }	
}

 

  } catch(e) { console.error(e); }
})();
})();
